import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useLocationHistoryStore } from '@/shared/stores';

export const LocationHistoryProvider = () => {
  const location = useLocation();

  useEffect(() => {
    useLocationHistoryStore.getState().setPreviousPath(location.pathname + location.search);
  }, [location]);

  return null;
};
